import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import {
	FormGroup,
	FormControl,
	FormLabel,
	Dropdown,
	OverlayTrigger,
	Tooltip,
	Popover,
	ButtonGroup,
	Button,
} from "react-bootstrap";
import InfiniteScroll from "react-infinite-scroll-component";
import { isSafari } from "react-device-detect";
import Moment from "react-moment";
import moment from "moment";
import "moment-timezone";
import {
	FiClock,
	FiPlus,
	FiMoreHorizontal,
	FiUpload,
	FiAlertTriangle,
	FiSliders,
	FiList,
} from "react-icons/fi";
import { FaRegFilePdf } from "react-icons/fa6";
import { MdOutlineTimer } from "react-icons/md";
import {
	FaMapMarkerAlt,
	FaMobileAlt,
	FaDesktop,
	FaRegComment,
} from "react-icons/fa";
import { GoAlert } from "react-icons/go";
import { FaSort, FaSortDown, FaSortUp } from "react-icons/fa";
import { TabletOrDesktop, Mobile } from "utils/responsive";
import * as timesActions from "actions/timesActions";
import * as employeesActions from "actions/employeesActions";
import * as groupsActions from "actions/groupsActions";
import * as ubicationsActions from "actions/ubicationsActions";
import { showModal, hideModal, updateModalLoading } from "actions/modalActions";
import {
	timesService,
	appService,
	accountsService,
	plansService,
	transactionsService,
	employeesService,
} from "services";
import { EmployeeLink } from "components/Employees/EmployeeEditDrawer";
import {
	getDiffTime,
	formatSecondsToTime,
	formatMinutesToTime,
	getWorkedTimeRaw,
	getBalanceHours,
	buildTimeRegistrationReportEntries,
	getPlannedRestDays,
} from "utils/datetime";
import Layout from "components/Layout";
import Loading from "components/Loading";
import Modal from "components/Modal";
import Switch from "components/Switch";
import TimeObservationEdit from "components/TimeRegistrations/TimeObservationEditModal";
import TimeRegistrationUbicationSelect from "components/TimeRegistrations/TimeRegistrationUbicationSelect";
import TimesNavigationTabs from "components/Times/TimesNavigationTabs";
import "react-dates/lib/css/_datepicker.css";
import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import { isAdmin, shouldIncludeSupervised } from "utils/utils";
import { TIME_ALERTS } from "components/Times/utils";
import { TIME_LIST_VIEWS } from "components/Times/utils";
import { convertFromUTC } from "utils/datetime";
import { getAppName } from "utils/utils";
import { formatLocalizedDate } from "utils/dateConfig";
import {
	trackHaddockEvent,
	getApprovalActorProps,
} from "utils/posthogTracking";
import { withTranslation } from "react-i18next";
import { hasTimeChatOrAttachments } from "utils/timeChatUtils";
import { createApprovalLock } from "utils/approvalInFlight";
import {
	toSelectOptions,
	withUbicationId,
} from "components/TimeRegistrations/timeRegistrationUbication";

class Times extends Component {
	constructor(props) {
		super(props);
		// console.log(props);

		const today = new Date();
		var storedStartDate = localStorage.getItem("times_startDate");
		var storedEndDate = localStorage.getItem("times_endDate");
		var storedSearchEmployee = localStorage.getItem("times_searchEmployee");
		var storedFilterGroupId = localStorage.getItem("times_filterGroupId");
		var storedFilterUbicationId = localStorage.getItem("times_filter_ubication_id");
		var startDate =
			storedStartDate && storedStartDate !== "null"
				? storedStartDate
				: moment(today).startOf("month").format("YYYY-MM-DD");
		var endDate =
			storedEndDate && storedEndDate !== "null"
				? storedEndDate
				: moment(today).endOf("month").format("YYYY-MM-DD");

		// var startDate = moment(today).startOf("month").format("YYYY-MM-DD");
		// var endDate = moment(today).endOf("month").format("YYYY-MM-DD");

		this.state = {
			loading: true,
			error: false,
			times: [],
			total_time: 0,
			total_working_time: 0,
			searchEmployee: storedSearchEmployee ? storedSearchEmployee : "",
			startDate,
			endDate,
			filterGroupId: storedFilterGroupId ? storedFilterGroupId : "",
			filter_ubication_id: storedFilterUbicationId
				? storedFilterUbicationId
				: "-1",
			filter_approved: false,
			sort: "+employee,+day",
			focusedInput: null,
			page: 0, // result pagination
			hasMore: true, // time list has more results to fetch
			include_approved_workflows: false,
			showFilterOptions: false,
			filter_alertas: -1,
			is_list_view: false,
			time_list_view: TIME_LIST_VIEWS.employee_day,
			show_rest_time: false,
			objective_hours: [],
			planned_hours: [],
			employee_ubication_options: {},
			approvingDayKeys: {},
		};
		this.approvalLock = createApprovalLock();

		this.closeModal = this.closeModal.bind(this);
		this.openExportModal = this.openExportModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
		this.openObservationsModal = this.openObservationsModal.bind(this);
	}

	componentDidMount() {
		this.props.getSelectableEmployees();
		this.props.getSelectableUbications();
		this.getTimes();
		this.getGroups();
		this.getObjectiveHoursList();
	}

	async getGroups() {
		await this.props.getAllGroups();
	}

	// Employee view list / grid
	//list: 1,
	//employee_day: 2,
	//employee_week: 3,
	handleChangeView = (time_list_view) => {
		this.setState({
			is_list_view: time_list_view === 1,
			time_list_view,
		});
	};

	fetchMoreData = () => {
		const { page } = this.state;
		this.setState(
			{
				page: page + 1,
			},
			() => {
				this.getTimes();
				this.getObjectiveHoursList();
			}
		);
	};

	async getTimeAlerts(time_list) {
		const {
			searchEmployee,
			startDate,
			endDate,
			filterGroupId,
			filter_approved,
			page,
			sort,
			not_ended,
		} = this.state;

		const response_alerts = await timesService.alerts({
			employee_id: searchEmployee,
			start_from: startDate,
			start_to: endDate,
			group_id: filterGroupId,
			page,
			sort,
			not_ended,
			include_supervised: shouldIncludeSupervised(),
			pending_only: filter_approved,
			ubication_id: this.getUbicationFilterParam(),
		});
		let times_with_alerts = time_list.map((item) => {
			if (response_alerts.ok) {
				const alerts = response_alerts.filter(
					(a) => a.time_registration_id === item.id
				);
				item.alerts = alerts ? alerts : [];
			} else {
				item.alerts = [];
			}
			return item;
		});
		return times_with_alerts;
	}

	async getTimes() {
		const {
			times,
			searchEmployee,
			startDate,
			endDate,
			filterGroupId,
			filter_approved,
			page,
			sort,
			not_ended,
			filter_alertas,
		} = this.state;

		this.setState({
			loading: true,
		});
		const response = await timesService.getAll({
			employee_id: searchEmployee,
			start_from: startDate,
			start_to: endDate,
			group_id: filterGroupId,
			page,
			sort,
			not_ended,
			include_supervised: shouldIncludeSupervised(),
			pending_only: filter_approved,
			ubication_id: this.getUbicationFilterParam(),
		});

		// console.log(response);

		if (response.ok) {
			let new_times = response.data;

			if (new_times.length > 0) new_times = await this.getTimeAlerts(new_times);

			// console.log(new_times);

			if (page > 0) {
				new_times = times.concat(new_times);
			}

			// filter_alertas -1 todos los fichajes
			// filter_alertas 0 sin alertas
			// filter_alertas 1 con alertas
			if (parseInt(filter_alertas) === 0) {
				// console.log("sin alertas");
				new_times = new_times.filter((t) => t.alerts.length === 0);
			}
			if (filter_alertas > 0) {
				// console.log("con alertas");
				new_times = new_times.filter((t) => t.alerts && t.alerts.length > 0);
			}

			this.setState({
				times: new_times,
				total_time:
					response.aggregates && response.aggregates.overall_seconds
						? response.aggregates.overall_seconds
						: 0,
				total_working_time:
					response.aggregates && response.aggregates.working_seconds
						? response.aggregates.working_seconds
						: 0,
				loading: false,
				hasMore: response.data.length > 0,
			});
			this.hydrateEmployeeUbications(new_times);
		} else {
			this.setState({
				error: true,
				loading: false,
			});
		}
	}

	openObservationsModal(time, titleObservations) {
		this.props.showModal(
			{
				open: true,
				title: titleObservations,
				style: { width: "520px", maxWidth: "95vw" },
				content: (
					<TimeObservationEdit
						isReadonly={true}
						time={time}
						employee={time.employee}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	handleReport = async () => {
		const { times, startDate, endDate } = this.state;

		if (!times || times.length === 0) {
			console.warn("No hay fichajes disponibles.");
			return;
		}

		// Obtener nombre completo del trabajador
		const { name, surname, company, nif } = times[0].employee;
		const nombreTrabajador = nif
			? `${name} ${surname} (NIF: ${nif})`
			: `${name} ${surname}`;
		const nombreEmpresa = company?.name || "-";
		const cifEmpresa = company?.vat_number || "-";
		const fechaGeneracion = formatLocalizedDate(moment(), "longWithTime");
		const periodo = `${formatLocalizedDate(startDate, "long")} – ${formatLocalizedDate(endDate, "long")}`;

		let plannedRestDays = [];
		try {
			const planResponse = await plansService.getPlanAssignments({
				employee_id: times[0].employee?.id,
				start: moment(startDate).format("YYYY-MM-DD"),
				end: moment(endDate).format("YYYY-MM-DD"),
				page_size: 10000,
			});
			plannedRestDays = getPlannedRestDays(planResponse?.data);
		} catch (error) {
			console.warn("No se pudieron obtener los descansos planificados:", error);
		}

		const { entries: reportEntries, totalRestSeconds } =
			buildTimeRegistrationReportEntries(
				times,
				this.props.t('times.pdf.weeklyRest'),
				{
					employeeId: times[0].employee?.id,
					plannedRestDays,
				}
			);

		// Crear una fila por fichaje y otra por cada descanso semanal planificado.
		const fichajes = reportEntries.map((entry) => {
			const dia = moment(entry.day, "YYYY-MM-DD").format("L");
			const entrada = entry.start
				? moment(entry.start).local().format("HH:mm")
				: "-";
			const salida = entry.end
				? moment(entry.end).local().format("HH:mm")
				: "-";
			const duracion = entry.kind === "day-rest"
				? "-"
				: entry.end
				? moment.duration(entry.durationSeconds, "seconds").humanize()
				: "-";

			return { dia, entrada, salida, tipo: entry.typeName, duracion };
		});
		const appName = getAppName();

		const mainColor = appName === "Plain" ? [91, 73, 254] : [0, 0, 0];

		// Crear documento PDF
		const doc = new jsPDF();

		// TÍTULO PRINCIPAL
		doc.setFontSize(16);
		doc.text(this.props.t('times.pdf.title'), 14, 16);

		// Cabecera con bordes usando autoTable
		autoTable(doc, {
			startY: 20,
			body: [
				[this.props.t('times.pdf.company'), nombreEmpresa],
				[this.props.t('times.pdf.cif'), cifEmpresa],
				[this.props.t('times.pdf.worker'), nombreTrabajador],
				[this.props.t('times.pdf.generationDate'), fechaGeneracion],
				[this.props.t('times.pdf.source'), appName],
				[this.props.t('times.pdf.period'), periodo],
			],
			styles: {
				fontSize: 10,
				cellPadding: 2,
			},
			tableLineColor: [190, 190, 190],
			tableLineWidth: 0.1,
			columnStyles: {
				0: { fontStyle: "bold" },
				1: {},
			},
		});

		// SUBTÍTULO ANTES DE LA TABLA DE FICHAJES
		const yAfterHeader = doc.lastAutoTable.finalY + 10;
		doc.setFontSize(12);
		doc.text(this.props.t('times.pdf.timesSubtitle'), 14, yAfterHeader);

		// Fichajes: tabla principal
		autoTable(doc, {
			startY: yAfterHeader + 4,
			head: [
				[
					this.props.t('times.pdf.day'),
					this.props.t('times.pdf.entryTime'),
					this.props.t('times.pdf.exitTime'),
					this.props.t('times.pdf.timeType'),
					this.props.t('times.pdf.duration'),
				],
			],
			body: fichajes.map((f) => [f.dia, f.entrada, f.salida, f.tipo, f.duracion]),
			styles: {
				fontSize: 10,
				cellPadding: 2,
			},
			tableLineColor: mainColor,
			tableLineWidth: 0.1,
			headStyles: {
				fillColor: mainColor,
				textColor: 255,
				halign: "center",
				cellPadding: 2,
			},
			bodyStyles: {
				halign: "left",
				cellPadding: 2,
				lineWidth: 0.1,
			},
		});

		autoTable(doc, {
			startY: doc.lastAutoTable.finalY + 6,
			head: [[this.props.t('times.pdf.summary'), ""]],
			body: [
				[
					this.props.t('times.pdf.restTime'),
					formatSecondsToTime(totalRestSeconds, "hm"),
				],
			],
			styles: { fontSize: 10, cellPadding: 2 },
			tableLineColor: mainColor,
			tableLineWidth: 0.1,
			headStyles: {
				fillColor: mainColor,
				textColor: 255,
				halign: "left",
			},
			columnStyles: { 0: { fontStyle: "bold" }, 1: {} },
			tableWidth: "auto",
		});

		// Añadir número de página en cada hoja
		const pageCount = doc.internal.getNumberOfPages();
		for (let i = 1; i <= pageCount; i++) {
			doc.setPage(i);
			doc.setFontSize(9);
			doc.text(this.props.t('times.pdf.page', { current: i, total: pageCount }), 195, 290, { align: "right" });
		}

		// Guardar PDF
		doc.save(`informe_horario_${nombreTrabajador}.pdf`);
	};

	async handleExport() {
		const userId = this.state.searchEmployee;
		const { startDate, endDate, filterGroupId, include_approved_workflows } =
			this.state;
		const token = await timesService.exportList({
			employee_id: userId,
			start_from: startDate,
			start_to: endDate,
			group_id: filterGroupId,
			include_approved_workflows,
			include_supervised: shouldIncludeSupervised(),
		});

		if (token.ok) {
			this.openExportModal(token.access_token, "fichajes.xlsx");
		} else {
			this.openAlertModal(
				this.props.t('times.exportError'),
				"Error al exportar"
			);
		}
	}

	async handleExportIncludeAllWorkflows() {
		const userId = this.state.searchEmployee;
		const { startDate, endDate, filterGroupId, include_approved_workflows } =
			this.state;
		const token = await timesService.exportList({
			employee_id: userId,
			start_from: startDate,
			start_to: endDate,
			group_id: filterGroupId,
			include_approved_workflows,
			include_supervised: shouldIncludeSupervised(),
			include_all_workflows: true,
		});

		if (token.ok) {
			this.openExportModal(token.access_token, "fichajes_ausencias.xlsx");
		} else {
			this.openAlertModal(
				this.props.t('times.exportError'),
				"Error al exportar"
			);
		}
	}

	async handleExportTimeRegistrationLog() {
		const userId = this.state.searchEmployee;
		const { startDate, endDate, filterGroupId } = this.state;
		const token = await timesService.exportLogs({
			employee_id: userId,
			start_from: startDate,
			start_to: endDate,
			group_id: filterGroupId,
			include_supervised: shouldIncludeSupervised(),
		});

		if (token.ok) {
			this.openExportModal(token.access_token, "auditoria_fichajes.xlsx");
		} else {
			this.openAlertModal(
				this.props.t('times.exportLogsError'),
				"Error al exportar"
			);
		}
	}

	openExportModal(token, filename) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('times.exportModalTitle'),
				style: { width: "400px" },
				confirmText: this.props.t('common.download'),
				loadingText: this.props.t('common.downloading'),
				message: this.props.t('times.exportModalMessage'),
				closeModal: this.closeModal,
				confirmAction: () => {
					this.props.updateModalLoading(true);
					this.downloadExport(token, filename);
				},
			},
			"confirm"
		);
	}

	async downloadExport(token, filename) {
		//console.log(token);
		const response = await appService.getExported(token);
		// console.log(response);

		var url = window.URL.createObjectURL(response);
		var a = document.createElement("a");
		document.body.appendChild(a);
		a.href = url;
		a.download = filename;
		a.click();

		this.props.updateModalLoading(false); // Cambiar a no cargando
		this.closeModal(); // cerrar modal de confirmación
	}

	closeModal() {
		this.props.hideModal();
	}

	getUbicationFilterParam = () => {
		const id = parseInt(this.state.filter_ubication_id, 10);
		return id > 0 ? id : undefined;
	};

	hydrateEmployeeUbications = async (timeList) => {
		const employeeIds = [
			...new Set(
				(timeList || [])
					.map((t) => t.employee?.id)
					.filter((id) => id != null)
			),
		];
		const { employee_ubication_options } = this.state;
		const missing = employeeIds.filter((id) => !employee_ubication_options[id]);
		if (missing.length === 0) return;

		const updates = { ...employee_ubication_options };

		for (const employeeId of missing) {
			const response = await employeesService.getUbications(employeeId);
			const assigned = response.ok ? response : [];
			updates[employeeId] = toSelectOptions(assigned, []);
		}

		this.setState({ employee_ubication_options: updates });
	};

	getUbicationOptionsForEmployee = (employeeId) => {
		const { employee_ubication_options } = this.state;

		if (employeeId != null && employee_ubication_options[employeeId] !== undefined) {
			return employee_ubication_options[employeeId];
		}

		return [];
	};

	getUbicationSelectValue = (time) => {
		if (time.ubication && time.ubication.id != null) {
			return time.ubication.id;
		}
		if (time.ubication_id != null && time.ubication_id > 0) {
			return time.ubication_id;
		}
		return -1;
	};

	handleSelectUbication = (event, id) => {
		const ubicationId = parseInt(event.target.value, 10);
		const row = this.state.times.find((t) => t.id === id);
		const options = this.getUbicationOptionsForEmployee(row?.employee?.id);
		const opt = options.find((o) => o.id === ubicationId);

		const updatedTimes = this.state.times.map((item) => {
			if (item.id !== id) return item;

			const updated = { ...item };
			if (ubicationId > 0 && opt) {
				updated.ubication = { id: opt.id, name: opt.name };
				updated.ubication_id = opt.id;
			} else {
				updated.ubication = null;
				updated.ubication_id = null;
			}
			this.saveTime(id, updated);
			return updated;
		});

		this.setState({ times: updatedTimes });
	};

	saveTime = async (id, state_time) => {
		if (!state_time?.start) return;

		const start_utc = moment.utc(state_time.start).format();
		const end_utc = state_time.end
			? moment.utc(state_time.end).format()
			: null;

		const timeBase = {
			start: start_utc,
			end: end_utc,
			approved: Boolean(state_time.approved),
			type_id: state_time.type ? state_time.type.id : -1,
			observations: state_time.observations,
			start_origin: state_time.start_origin,
			end_origin: state_time.end_origin,
			employee_id: state_time.employee?.id,
			start_source: state_time.start_source,
			end_source: state_time.end_source || "TIME_REGISTRATIONS",
		};

		const time = withUbicationId(timeBase, state_time, { echo: true });
		const response = await timesService.update(id, time);

		if (!response.ok) {
			const message =
				response.errors?.[0]?.description ||
				this.props.t("times.observationsModal.errorSaving");
			this.openAlertModal(message);

			const fetch_time = await timesService.getById(id);
			if (fetch_time?.id) {
				this.setState({
					times: this.state.times.map((t) =>
						t.id === id ? fetch_time : t
					),
				});
			}
		}
	};

	getUbication = (time, disabled) => {
		const options = this.getUbicationOptionsForEmployee(time.employee?.id);
		if (!options.length) {
			return time.ubication?.name || "";
		}

		return (
			<TimeRegistrationUbicationSelect
				id={`ubication_${time.id}`}
				disabled={disabled}
				value={this.getUbicationSelectValue(time)}
				options={options}
				onChange={(e) => this.handleSelectUbication(e, time.id)}
			/>
		);
	};

	openAlertModal(message, title) {
		this.props.showModal(
			{
				open: true,
				title: "Error" || title,
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	handleChangeSearch = (event) => {
		const key = event.target.id;
		const value = event.target.value;

		localStorage.setItem("times_" + key, value);

		this.setState(
			{
				page: 0, // reset pagination
				[key]: event.target.value,
			},
			() => {
				this.getTimes();
				this.getObjectiveHoursList();
			}
		);
	};

	handleSwitch = (event) => {
		const targetId = event.target.id;
		this.setState(
			{
				page: 0, // reset pagination
				[targetId]: event.target.checked,
			},
			() => {
				if (targetId !== "show_rest_time") {
					this.getTimes();
				}
			}
		);
	};

	onDatesChange = (dates) => {
		var { startDate, endDate } = dates;

		if (startDate) startDate = startDate.format("YYYY-MM-DD");

		if (endDate) {
			endDate = endDate.format("YYYY-MM-DD");
		}

		localStorage.setItem("times_startDate", startDate);
		localStorage.setItem("times_endDate", endDate);

		this.setState(
			{
				page: 0, // reset pagination
				startDate,
				endDate,
			},
			() => {
				this.getTimes();
			}
		);
	};

	getApprovalDayKey = (time) => {
		const employeeId = time.employee?.id || "unknown";
		return `${employeeId}:${moment(time.day).format("YYYY-MM-DD")}`;
	};

	markDayApproving = (dayKey, on) => {
		this.setState((prevState) => {
			const approvingDayKeys = { ...prevState.approvingDayKeys };
			if (on) approvingDayKeys[dayKey] = true;
			else delete approvingDayKeys[dayKey];
			return { approvingDayKeys };
		});
	};

	isDayApprovalInFlight = (time) => {
		const dayKey = this.getApprovalDayKey(time);
		return Boolean(this.state.approvingDayKeys[dayKey]);
	};

	// switch approval state
	handleTimeApproval = (event, time) => {
		const { times } = this.state;
		const isApproved = event.target.checked;
		const dayKey = this.getApprovalDayKey(time);
		if (!this.approvalLock.tryBegin(dayKey)) {
			return;
		}
		this.markDayApproving(dayKey, true);

		var approvalList = [];
		const updatedTimes = times.map((item) => {
			const sameDay =
				moment(item.day).format("YYYY-MM-DD") ===
				moment(time.day).format("YYYY-MM-DD");

			if (
				sameDay &&
				item.employee.id === time.employee.id &&
				((item.start !== null && item.end !== null) || item.day_of_rest)
			) {
				approvalList.push({ id: item.id, approved: isApproved });
				return { ...item, approved: isApproved };
			}
			return item;
		});

		trackHaddockEvent("time_approval__single_day__toggled__times_page", {
			...getApprovalActorProps(this.props.user),
			surface: "times_page",
			action_type: "single_toggle",
			toggle_direction: isApproved ? "approve" : "unapprove",
			new_approved: isApproved,
			target_employee_id: time.employee?.id || null,
			target_day: moment(time.day).format("YYYY-MM-DD"),
			affected_records_count: approvalList.length,
			filter_start_date: this.state.startDate || null,
			filter_end_date: this.state.endDate || null,
			filter_group_id: this.state.filterGroupId || null,
			filter_pending_only: this.state.filter_approved,
			filter_not_ended: this.state.not_ended || false,
			filter_alerts: this.state.filter_alertas,
			time_list_view: this.state.time_list_view,
		});

		this.setState({ times: updatedTimes });
		this.handleApproval(updatedTimes, approvalList).finally(() => {
			this.approvalLock.end(dayKey);
			this.markDayApproving(dayKey, false);
		});
	};

	handlePeriodApproval = () => {
		if (!this.approvalLock.tryBegin("period")) return;

		const { times } = this.state;
		var approvalList = [];

		const updatedTimes = times.map((item) => {
			if (item.start !== null && item.end !== null && item.end !== undefined) {
				if (!item.approved) {
					approvalList.push({ id: item.id, approved: true });
					return { ...item, approved: true };
				}
			}
			return item;
		});

		trackHaddockEvent("time_approval__bulk_filtered__clicked__times_page", {
			...getApprovalActorProps(this.props.user),
			surface: "times_page",
			action_type: "bulk_click",
			bulk_scope: "filtered_results",
			candidate_records_count: times.length,
			affected_records_count: approvalList.length,
			filter_start_date: this.state.startDate || null,
			filter_end_date: this.state.endDate || null,
			filter_group_id: this.state.filterGroupId || null,
			filter_pending_only: this.state.filter_approved,
			filter_not_ended: this.state.not_ended || false,
			filter_alerts: this.state.filter_alertas,
			time_list_view: this.state.time_list_view,
		});

		this.setState({ times: updatedTimes });
		this.handleApproval(updatedTimes, approvalList).finally(() => {
			this.approvalLock.end("period");
		});
	};

	handleApproval = async (updatedTimes, approvalList) => {
		const response = await timesService.approve(approvalList);

		if (response.ok) {
			this.setState({
				times: updatedTimes,
			});
		} else {
			// show error
			let textError = response.errors[0].description;

			this.openAlertModal(textError, "Error al aprobar fichajes");
			this.getTimes();
		}
	};

	handleSort(action) {
		const { sort, is_list_view } = this.state;
		// console.log(sort);
		// console.log(action);

		let newSort = sort;

		// Aplicar lógica especial solo en la vista específica
		if (is_list_view) {
			const defaultSortFields = ["employee", "day"];
			defaultSortFields.forEach((field) => {
				if (!sort.includes(field)) {
					newSort = `+${field},${newSort}`; // Añadir con orden ascendente por defecto si falta
				}
			});

			const sortParts = newSort.split(",").map((part) => ({
				field: part.substring(1),
				direction: part.substring(0, 1),
			}));

			// Encuentra si el action ya está en el ordenamiento
			const actionIndex = sortParts.findIndex((part) => part.field === action);

			if (actionIndex > -1) {
				// Cambiar el signo si el campo ya estaba
				sortParts[actionIndex].direction =
					sortParts[actionIndex].direction === "+" ? "-" : "+";
			} else {
				// Añadir el nuevo campo con signo positivo si no estaba
				sortParts.push({ field: action, direction: "+" });
			}

			// Reconstruir la cadena de ordenamiento
			newSort = sortParts
				.map((part) => `${part.direction}${part.field}`)
				.join(",");
		} else {
			// Lógica de ordenamiento estándar para otras vistas
			const newSorting = sort.substring(0, 1) === "+" ? "-" : "+";
			newSort = `${newSorting}${action}`;
		}

		// console.log(newSort);

		this.setState(
			{
				page: 0,
				sort: newSort,
			},
			() => {
				this.getTimes();
			}
		);
	}

	// handleSort(action) {
	// 	const { sort } = this.state;
	// 	if (sort !== action) {
	// 		const newSorting = sort.substring(0, 1) === "+" ? "-" : "+";
	// 		this.setState(
	// 			{
	// 				page: 0,
	// 				sort: newSorting + action,
	// 			},
	// 			() => {
	// 				this.getTimes();
	// 			}
	// 		);
	// 	}
	// }

	// get objective hours list by employee and month
	async getObjectiveHoursList() {
		var { searchEmployee, account_objetivo, startDate, endDate } = this.state;

		// console.log("getObjectiveHoursList");
		// console.log({ searchEmployee });
		this.setState({
			loading: true,
		});

		if (!account_objetivo) {
			account_objetivo = await accountsService.getAll("Horas objetivo"); // guarrofix
		}

		const account_objetivo_id =
			account_objetivo.data.length > 0 ? account_objetivo.data[0].id : -1;

		// fetch horas objetivo
		const response_objective = await transactionsService.getAll(
			searchEmployee,
			account_objetivo_id,
			startDate,
			endDate,
			"",
			0,
			"+day",
			100000
		);
		const response_planned = await plansService.getPlannedHours({
			employee_id: searchEmployee,
			start: startDate,
			end: endDate,
		});
		// console.log(employee_id);
		// console.log(response_objective);
		// console.log(response_planned);

		this.setState({
			loading: false,
			account_objetivo,
			objective_hours: response_objective.data,
			planned_hours: response_planned.ok ? response_planned : [],
		});
	}

	getBalanceByDay = (day, list, employee_id) => {
		const filtered_hours = list.filter((d) => {
			let selected_day = moment.utc(day).local().format("D");
			let d_day = moment.utc(d.day).local().format("D");

			return selected_day === d_day && d.employee.id === employee_id;
		});

		// console.log(filtered_hours);
		const suma = filtered_hours.reduce((acc, numero) => acc + numero.value, 0);

		var return_value = 0;
		if (filtered_hours.length === 1) return_value = filtered_hours[0].value;
		else if (filtered_hours.length > 1) return_value = suma;

		const formattedValue = new Intl.NumberFormat("de-DE", {
			minimumFractionDigits: 1,
			maximumFractionDigits: 2,
		}).format(return_value);
		return formattedValue;
	};

	getSortableTh = (name, action, extraclass) => {
		const { sort } = this.state;

		let symbol = <FaSort className="icon-sort" />;
		if (sort.substring(1) === action) {
			symbol =
				sort.substring(0, 1) === "+" ? (
					<FaSortUp className="icon-sort icon-sort-up" />
				) : (
					<FaSortDown className="icon-sort icon-sort-down" />
				);
		}

		return (
			<th
				className={`sortable-item ${extraclass !== null ? extraclass : ""}`}
				onClick={() => this.handleSort(action)}
			>
				{name} {symbol}
			</th>
		);
	};

	getContent = () => {
		// console.log(this.state);
		const { loading, error, times, hasMore, is_list_view, show_rest_time } =
			this.state;

		if (loading) {
			return <Loading />;
		}

		if (error) {
<div className="no-results">{this.props.t('times.errorLoading')}</div>
		}
		return (
			<InfiniteScroll
				dataLength={times.length}
				next={this.fetchMoreData}
				endMessage={
					times.length > 0 && (
						<p className="no-more-results">{this.props.t('times.noMoreRecords')}</p>
					)
				}
				hasMore={hasMore}
				loader={<Loading />}
			>
				<Mobile>
					<div className="table-mobile-container">
						<table className="table table-times table-mobile">
							<tbody>
								{times.length === 0 ? this.getEmptyRow() : this.getRowsMobile()}
							</tbody>
						</table>
					</div>
				</Mobile>

				<TabletOrDesktop>
					<table
						className={`${
							!is_list_view && show_rest_time ? "table-rested" : ""
						} table table-times table-zebra`}
					>
						<thead>
							<tr>
								{this.getSortableTh(this.props.t('common.employee'), "employee")}
								{/* {this.getSortableTh("Código empleado", "code")} */}
								<th title={this.props.t('times.table.codeTitle')}>{this.props.t('times.table.code')}</th>
								{this.getSortableTh(this.props.t('common.day'), "day")}
								<th>{this.props.t('common.start')}</th>
								<th>{this.props.t('common.end')}</th>
								<th>{this.props.t('times.table.hours')}</th>
								{this.getSortableTh(this.props.t('common.type'), "type")}
								<th>{this.props.t('times.table.ubication')}</th>
								{this.getSortableTh(this.props.t('times.table.created'), "created")}
								<th></th>
								{!is_list_view && <th>{this.props.t('times.table.dayTotal')}</th>}
								{!is_list_view && <th>{this.props.t('times.table.balance')}</th>}
								{this.getSortableTh(this.props.t('times.table.approved'), "approved", "aright")}
							</tr>
						</thead>
						<tbody>
							{times.length === 0 ? this.getEmptyRow() : this.getRows()}
						</tbody>
					</table>
				</TabletOrDesktop>
			</InfiniteScroll>
		);
	};

	getEmptyRow = () => {
		const { is_list_view } = this.state;
		return (
			<>
				<Mobile>
					<tr>
						<td colSpan="4" className="no-result">
							Sin resultados
						</td>
					</tr>
				</Mobile>
				<TabletOrDesktop>
					<tr>
						<td className="no-result" colSpan={`${is_list_view ? "11" : "13"}`}>
							Sin resultados
						</td>
					</tr>
				</TabletOrDesktop>
			</>
		);
	};

	getTooltipAlert = (time) => {
		if (!time.alerts || time.alerts.length < 1) return "";

		return (
			<Tooltip className="tooltip-alerta">
				<ul>{this.getTooltipAlertContent(time.alerts)}</ul>
			</Tooltip>
		);
	};

	getTooltipAlertContent = (alerts) =>
		alerts.map((alert, i) => {
			const plan_time = convertFromUTC(alert.plan_time);
			return (
				<li key={i}>
					<GoAlert className="tooltip-icon icon-alert" />{" "}
					{this.props.t('times.alerts.' + alert.type)}
					{alert.plan_time && <>. {this.props.t('times.alerts.planned')}: {plan_time}</>}
				</li>
			);
		});

	getPopoverLocation = (time, isStart) => {
		const ip = isStart ? time.start_ip : time.end_ip;
		const lat = isStart ? time.start_lat : time.end_lat;
		const lon = isStart ? time.start_lon : time.end_lon;
		const device = isStart ? time.start_origin : time.end_origin;
		const url = `https://www.google.com/maps?q=${lat},${lon}`;

		return (
			<Popover className="popover-location">
				<div className="popover-content">
					<ul>
						{ip && (
							<li>
								<strong>IP:</strong> {ip}
							</li>
						)}
						{lat && (
							<li>
								<strong>LAT:</strong> {lat}
							</li>
						)}
						{lon && (
							<li>
								<strong>LON:</strong> {lon}
							</li>
						)}
						{device && (
							<li>
								<strong>Dispositivo:</strong> {device}
							</li>
						)}
					</ul>

					{((isStart && time.start_lat && time.start_lon) ||
						(!isStart && time.end_lat && time.end_lon)) && (
						<a href={url} target="_blank">
							Ver en Google Maps
						</a>
					)}
				</div>
			</Popover>
		);
	};

	getObservations = (time) => {
		return (
			<FaRegComment
				className="icon-comment"
				title={this.props.t('times.chat.viewConversation')}
				onClick={() =>
					this.openObservationsModal(
						time,
						this.props.t('times.table.viewObservations')
					)
				}
			/>
		);
	};

	getRows = () =>
		this.state.times.map((time, i) => {
			const { is_list_view, show_rest_time, objective_hours, planned_hours } =
				this.state;
			var isMain = true;
			const start = new Date(time.start);
			const end = new Date(time.end);
			const minutes = getDiffTime(start.setSeconds(0, 0), end.setSeconds(0, 0));
			const totalTime = formatMinutesToTime(minutes);
			var disabled = time.approved;
			const formatted_start = moment.utc(time.start).local().format("HH:mm");
			const formatted_end = time.end
				? moment.utc(time.end).local().format("HH:mm")
				: "--:--";
			var extraRow = null;
			const balance_calcularion =
				this.props.user.time_registration_balance_calculation;

			// console.log(time);

			if (i > 0 && !is_list_view) {
				const prev_date = new Date(this.state.times[i - 1].day).getDate();
				const now = new Date(time.day).getDate();
				const prev_employee = this.state.times[i - 1].employee.id;
				const current_employee = time.employee.id;

				if (prev_date === now && prev_employee === current_employee)
					isMain = false;

				var showRest = true;
				const prev_end = new Date(this.state.times[i - 1].end);
				const diff = getDiffTime(
					prev_end.setSeconds(0, 0),
					start.setSeconds(0, 0)
				);
				const formatted_diff = formatMinutesToTime(diff);

				if (current_employee !== prev_employee || prev_date !== now) {
					showRest = false;
				}

				if (show_rest_time && showRest && diff > 0) {
					extraRow = (
						<tr className="tr-rest">
							<td colSpan="11">{this.props.t("shifts.form.typeRest")} {formatted_diff}</td>
						</tr>
					);
				}
			}

			const tooltip_alert = this.getTooltipAlert(time);
			const tooltip_switch = this.getToolTipSwitch(time);
			const popover_location_start = this.getPopoverLocation(time, true);
			const popover_location_end = this.getPopoverLocation(time, false);
			const hasStartLocation = time.start_lat || time.start_lon;
			const hasStartDevice = time.start_origin;
			const hasEndLocation = time.end_lat || time.end_lon;
			const hasEndDevice = time.end_origin;

			const startDeviceIcon =
				hasStartDevice && hasStartDevice.substring(0, 4) === "[PC]" ? (
					<FaDesktop className="icon" />
				) : (
					<FaMobileAlt className="icon" />
				);
			const endDeviceIcon =
				hasEndDevice && hasEndDevice.substring(0, 4) === "[PC]" ? (
					<FaDesktop className="icon" />
				) : (
					<FaMobileAlt className="icon" />
				);

			const startIcon = hasStartLocation ? (
				<FaMapMarkerAlt className="icon" />
			) : (
				startDeviceIcon
			);
			const endIcon = hasEndLocation ? (
				<FaMapMarkerAlt className="icon" />
			) : (
				endDeviceIcon
			);
			const popoverTrigger = isSafari ? "click" : "focus";

			var dayTotal = -1;
			var balance = 0;
			var balanceTitle = "";
			var tooltipInfo = "";
			var sTipoTiempo = "";

			if (isMain) {
				var total_raw = getWorkedTimeRaw({
					times: this.state.times,
					date: time.start,
					unit: "seconds",
					employee_id: time.employee.id,
				});
				dayTotal = formatSecondsToTime(total_raw, "hm");

				const objective_hours_day = this.getBalanceByDay(
					time.day,
					objective_hours,
					time.employee.id
				);
				const planned_hours_day = this.getBalanceByDay(
					time.day,
					planned_hours,
					time.employee.id
				);
				// console.log(objective_hours);
				// console.log(planned_hours);
				// console.log(objective_hours_day);
				// console.log(planned_hours_day);

				if (minutes > 0) {
					if (balance_calcularion === "TARGET_HOURS") {
						// horas objetivo
						balance = getBalanceHours(objective_hours_day, total_raw);
						sTipoTiempo = " " + this.props.t('times.balance.targetHours');
					} else {
						// horas planificadas
						balance = getBalanceHours(planned_hours_day, total_raw);
						sTipoTiempo = " " + this.props.t('times.balance.plannedHours');
					}

					// console.log(balance.short_raw);

					if (balance.short_raw > 0)
						balanceTitle = (
							<p className="tooltip-title">
								{this.props.t('times.balance.excessText')}{" "}
								<strong>{balance.formated}</strong> {this.props.t('times.balance.accordingTo')}{sTipoTiempo}
							</p>
						);

					if (balance.short_raw < 0)
						balanceTitle = (
							<p className="tooltip-title">
								{this.props.t('times.balance.shortText')} <strong>{balance.formated}</strong> {this.props.t('times.balance.shortSuffix')}
								{sTipoTiempo}
							</p>
						);

					tooltipInfo = (
						<Tooltip className="tooltip-balance">
							<p>
								{this.props.t('times.balance.targetLabel')}: <strong>{objective_hours_day}h</strong>
							</p>
							<p>
								{this.props.t('times.balance.plannedLabel')}: <strong>{planned_hours_day}h</strong>
							</p>
							{balanceTitle}
						</Tooltip>
					);
				}
			}

			return (
				<>
					{extraRow}
					<tr
						key={time.id}
						className={`${isMain ? "main" : "repetida"} tr-body`}
					>
						<td>
							<div className="tag-name-container">
								<EmployeeLink
									employee={time.employee}
									to={`/times/${time.employee.id}/employee`}
								>
									{time.employee.name} {time.employee.surname}
								</EmployeeLink>
							</div>
						</td>
						<td>{time.employee.code}</td>
						<td>
							<div className="tag-dia-container">
								<span className="d-none d-lg-inline-block tag-dia-setmana">
									<Moment format="dddd">{time.start}</Moment>
								</span>
								<Moment format="D MMMM YYYY">{time.start}</Moment>
							</div>
						</td>
						<td>
							{hasStartLocation || hasStartDevice ? (
								<OverlayTrigger
									overlay={popover_location_start}
									trigger={popoverTrigger}
									delay={{ show: 250, hide: 300 }}
								>
									<button
										type="button"
										className="btn-transparent btn-time-location"
									>
										<span>{formatted_start}</span> {startIcon}
									</button>
								</OverlayTrigger>
							) : (
								<span>{formatted_start}</span>
							)}
						</td>
						<td>
							{hasEndLocation || hasEndDevice ? (
								<OverlayTrigger
									overlay={popover_location_end}
									trigger={popoverTrigger}
									delay={{ show: 250, hide: 300 }}
								>
									<button
										type="button"
										className="btn-transparent btn-time-location"
									>
										<span>{formatted_end}</span> {endIcon}
									</button>
								</OverlayTrigger>
							) : (
								<span>{formatted_end}</span>
							)}
						</td>
						<td>{totalTime}</td>
						<td>{time.type && time.type.name}</td>
						<td className="col-time-reg-ubication">
							{this.getUbication(time, disabled)}
						</td>
						<td>
							<Moment format="DD/MM/YY | HH:mm">{time.created}</Moment>
						</td>
						<td className="acenter">
							{hasTimeChatOrAttachments(time) && this.getObservations(time)}

							{time.alerts.length > 0 && (
								<OverlayTrigger overlay={tooltip_alert}>
									<FiAlertTriangle className="icon-alert" />
								</OverlayTrigger>
							)}
						</td>
						{!is_list_view && (
							<td className="col-total">
								<strong>
									<span className="total">
										{dayTotal !== -1 && minutes !== 0 ? dayTotal : ""}
									</span>
								</strong>
							</td>
						)}
						{!is_list_view && (
							<td className="col-balance">
								<OverlayTrigger overlay={tooltipInfo}>
									<span
										className={`${
											balance.short_raw >= 0 ? "color-green-dark" : ""
										}  ${balance.short_raw < 0 ? "color-red" : ""}`}
									>
										{balance.short}
									</span>
								</OverlayTrigger>
							</td>
						)}
						<td className="aright">
							<OverlayTrigger placement="left" overlay={tooltip_switch}>
								<div className="switch-container-overlay">
									<Switch
										controlId={`approved_${time.id}`}
										isOn={disabled}
										disabled={this.isDayApprovalInFlight(time)}
										handleToggle={(e) => this.handleTimeApproval(e, time)}
									/>
								</div>
							</OverlayTrigger>
						</td>
					</tr>
				</>
			);
		});

	getToolTipSwitch = (time) => {
		var text = time.approved ? this.props.t('times.switch.disapprove') : this.props.t('times.switch.approve');
		text += " " + this.props.t('times.switch.suffix');

		return <Tooltip className="tooltip-switch">{text}</Tooltip>;
	};

	getRowsMobile = () =>
		this.state.times.map((time) => {
			const start = new Date(time.start);
			const end = new Date(time.end);
			const minutes = getDiffTime(start.setSeconds(0, 0), end.setSeconds(0, 0));
			const totalTime = formatMinutesToTime(minutes);
			var disabled = time.approved;

			const tooltip = this.getTooltipAlert(time);
			const tooltip_switch = this.getToolTipSwitch(time);

			return (
				<tr key={time.id}>
					<td>
						<EmployeeLink
							employee={time.employee}
							to={`/times/${time.employee.id}/employee`}
						>
							{time.employee.name} {time.employee.surname}
						</EmployeeLink>
						<br />
						<span className="d-none d-sm-inline-block tag-dia-setmana">
							<Moment format="dddd">{time.start}</Moment>
						</span>

						<Moment className="d-inline-block d-sm-none" format="DD/MM/YYYY">
							{time.start}
						</Moment>
						<Moment className="d-none d-sm-inline-block" format="D MMMM">
							{time.start}
						</Moment>
					</td>
					<td>
						<span>{moment.utc(time.start).local().format("HH:mm")}</span>
						<br />{" "}
						<span>
							{time.end
								? moment.utc(time.end).local().format("HH:mm")
								: "--:--"}
						</span>
					</td>
					<td>
						<strong>{totalTime}</strong>
						<br />
						{time.type && time.type.name}
					</td>
					<td>{hasTimeChatOrAttachments(time) && this.getObservations(time)}</td>
					<td>
						{time.alerts.length > 0 && (
							<OverlayTrigger overlay={tooltip}>
								<FiAlertTriangle className="icon-alert" />
							</OverlayTrigger>
						)}
					</td>
					<td className="aright">
						<OverlayTrigger placement="left" overlay={tooltip_switch}>
							<div className="switch-container-overlay">
								<Switch
									controlId={`approved_${time.id}`}
									isOn={disabled}
									disabled={this.isDayApprovalInFlight(time)}
									handleToggle={(e) => this.handleTimeApproval(e, time)}
								/>
							</div>
						</OverlayTrigger>
					</td>
				</tr>
			);
		});

	toggleFilterOptions = () => {
		this.setState({
			showFilterOptions: !this.state.showFilterOptions,
		});
	};

	isInformed = (value) => {
		return (
			value !== undefined && value !== null && value !== "" && value !== "null"
		);
	};

	render() {
		const {
			not_ended,
			filter_approved,
			include_approved_workflows,
			showFilterOptions,
			filter_alertas,
			time_list_view,
			show_rest_time,
			is_list_view,
			searchEmployee,
			startDate,
			endDate,
		} = this.state;
		const { groups, select_employees, select_ubications } = this.props;

		const showGenerarInforme =
			this.isInformed(searchEmployee) &&
			this.isInformed(startDate) &&
			this.isInformed(endDate);

		// console.log(searchEmployee);
		// console.log(startDate);
		// console.log(endDate);
		// console.log(showGenerarInforme);

		const optionList =
			groups.length > 0 &&
			groups.map((item, i) => {
				return (
					<option key={i} value={item.id}>
						{item.name}
					</option>
				);
			}, this);

		// console.log(select_employees);

		let employeeList =
			select_employees.length > 0 &&
			select_employees.map((item, i) => {
				return (
					<option key={i} value={item.id}>
						{item.name} {item.surname}
					</option>
				);
			}, this);

		let ubicationFilterList =
			select_ubications?.length > 0 &&
			select_ubications.map((item) => (
				<option key={item.id} value={item.id}>
					{item.name}
				</option>
			));

		const total = formatSecondsToTime(this.state.total_time, "hms");
		const total_working = formatSecondsToTime(
			this.state.total_working_time,
			"hms"
		);

		return (
			<>
				<Layout className="page-times" context="times">
					<div className="heading">
						<div className="heading-left">
							<h1 className="title">{this.props.t('times.title')}</h1>
						</div>

						<div className="heading-filters">
							<ButtonGroup
								className="hidden-xs hidden-sm"
								aria-label="Times view"
							>
								<Button
									variant={`${
										TIME_LIST_VIEWS.list === time_list_view
											? "primary"
											: "default"
									}`}
									onClick={() => this.handleChangeView(TIME_LIST_VIEWS.list)}
								>
									{/* <FiList className="icon" /> */}
									{this.props.t('times.noGrouping')}
								</Button>
								<Button
									variant={`${
										TIME_LIST_VIEWS.employee_day === time_list_view
											? "primary"
											: "default"
									}`}
									onClick={() =>
										this.handleChangeView(TIME_LIST_VIEWS.employee_day)
									}
								>
									{/* <MdOutlineTimer className="icon" /> */}
									{this.props.t('times.groupByDay')}
								</Button>
							</ButtonGroup>

							<Dropdown className="dropdown-filter" show={showFilterOptions}>
								<Dropdown.Toggle
									variant="action"
									onClick={() => this.toggleFilterOptions()}
								>
									<FiSliders className="icono-filtro" title={this.props.t('times.moreFilters')} />
								</Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Header>{this.props.t('times.moreFilters')}</Dropdown.Header>

									<div className="dropdown-content">
										{!is_list_view && (
											<FormGroup
												className="form-group form-group-flex form-switch"
												controlId="show_rest_time"
											>
												<Switch
													controlId="show_rest_time"
													isOn={show_rest_time}
													handleToggle={this.handleSwitch}
												/>
												<FormLabel title={this.props.t('times.filter.showRestTitle')}>
													{this.props.t('times.filter.showRest')}
												</FormLabel>
											</FormGroup>
										)}

										<FormGroup
											className="form-group form-group-flex form-switch"
											controlId="not_ended"
										>
											<Switch
												controlId="not_ended"
												isOn={not_ended}
												handleToggle={this.handleSwitch}
											/>
											<FormLabel title={this.props.t('times.filter.showOpenTitle')}>
												{this.props.t('times.filter.showOpen')}
											</FormLabel>
										</FormGroup>

										<FormGroup
											className="form-group form-group-flex form-switch"
											controlId="filter_approved"
										>
											<Switch
												controlId="filter_approved"
												isOn={filter_approved}
												handleToggle={this.handleSwitch}
											/>
											<FormLabel title={this.props.t('times.filter.showPendingTitle')}>
												{this.props.t('times.filter.showPending')}
											</FormLabel>
										</FormGroup>

										<FormGroup
											className="form-group form-group-side"
											controlId="filter_alertas"
										>
											<FormLabel>{this.props.t('times.filter.alerts')}</FormLabel>
											<FormControl
												type="text"
												value={filter_alertas}
												placeholder={this.props.t('times.filter.alerts')}
												onChange={this.handleChangeSearch}
												as="select"
											>
												<option value="-1">{this.props.t('times.filter.showAll')}</option>
												<option value="0">{this.props.t('times.filter.showNoAlerts')}</option>
												<option value="1">{this.props.t('times.filter.showWithAlerts')}</option>
											</FormControl>
										</FormGroup>
									</div>
									<div className="dropdown-footer">
										<button
											type="button"
											className="btn btn-outline-primary"
											onClick={() => this.toggleFilterOptions()}
										>
											{this.props.t('common.close')}
										</button>
									</div>
								</Dropdown.Menu>
							</Dropdown>

							<FormGroup
								className="form-group form-select-user"
								controlId="searchEmployee"
							>
								<FormControl
									type="text"
									placeholder={this.props.t('common.searchPlaceholder')}
									value={this.state.searchEmployee}
									className={
										(!isAdmin() && !isSupervisor()) ||
										select_employees.length < 1
											? "hidden"
											: ""
									}
									onChange={this.handleChangeSearch}
									as="select"
								>
									<option value="">{this.props.t('common.allEmployees')}</option>
									{employeeList}
								</FormControl>
							</FormGroup>

							<FormGroup
								className="form-group form-search"
								controlId="filterGroupId"
							>
								<FormControl
									type="text"
									placeholder={this.props.t('common.searchPlaceholder')}
									value={this.state.filterGroupId}
									onChange={this.handleChangeSearch}
									as="select"
								>
									<option value="">{this.props.t('common.filterByGroup')}</option>
									{optionList}
								</FormControl>
							</FormGroup>

							<FormGroup
								className="form-group form-search"
								controlId="filter_ubication_id"
							>
								<FormControl
									as="select"
									value={this.state.filter_ubication_id}
									onChange={this.handleChangeSearch}
								>
									<option value="-1">
										{this.props.t('times.filter.ubication')}
									</option>
									{ubicationFilterList}
								</FormControl>
							</FormGroup>

							<DateRangePicker
								startDateId="startDateId"
								endDateId="endDateId"
								startDate={
									this.state.startDate ? moment(this.state.startDate) : null
								}
								endDate={this.state.endDate ? moment(this.state.endDate) : null}
								startDatePlaceholderText={this.props.t('common.start')}
								endDatePlaceholderText={this.props.t('common.end')}
								onDatesChange={this.onDatesChange}
								focusedInput={this.state.focusedInput}
								hideKeyboardShortcutsPanel={true}
								isOutsideRange={() => false}
								minimumNights={0}
								onFocusChange={(focusedInput) =>
									this.setState({ focusedInput })
								}
							/>
						</div>

						<div className="heading-actions">
							<Link
								to={`/times/${this.props.user.id}/employee`}
								title={this.props.t('times.registerTimes')}
								className="btn btn-new"
							>
								<FiPlus />
							</Link>

							<Dropdown>
								<Dropdown.Toggle variant="action">
									<FiMoreHorizontal />
								</Dropdown.Toggle>
								<Dropdown.Menu>
									{showGenerarInforme && (
										<Dropdown.Item
											as="button"
											onClick={() => this.handleReport()}
										>
											<FaRegFilePdf className="dropdown-icon" /> {this.props.t('times.dropdown.generateReport')}
										</Dropdown.Item>
									)}

									<Dropdown.Item
										as="button"
										onClick={() => this.handleExport()}
									>
										<FiUpload className="dropdown-icon" /> {this.props.t('times.dropdown.exportExcel')}
									</Dropdown.Item>

									<Dropdown.Item
										as="button"
										onClick={() => this.handleExportIncludeAllWorkflows()}
									>
										<FiUpload className="dropdown-icon" /> {this.props.t('times.dropdown.exportExcelAbsences')}
									</Dropdown.Item>

									<Dropdown.Item
										as="button"
										onClick={() => this.handleExportTimeRegistrationLog()}
									>
										<FiUpload className="dropdown-icon" /> {this.props.t('times.dropdown.exportExcelAudit')}
									</Dropdown.Item>

									<Dropdown.Item
										as="button"
										onClick={() => this.handlePeriodApproval()}
									>
										<FiClock className="dropdown-icon" /> {this.props.t('times.dropdown.approveAll')}
									</Dropdown.Item>

									<FormGroup
										className="form-group form-switch export-config"
										controlId="include_approved_workflows"
									>
										<Switch
											controlId="include_approved_workflows"
											isOn={include_approved_workflows}
											handleToggle={this.handleSwitch}
										/>
										<FormLabel>
											{this.props.t('times.dropdown.includeAbsences')}
										</FormLabel>
									</FormGroup>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					</div>

					<TimesNavigationTabs />

					<div className="subheading">
						<span className="summary">
							<FiClock className="summary-icon" />
							<span>
								{this.props.t('times.summary.total')} <strong>{total}</strong> | {this.props.t('times.summary.totalWorked')}{" "}
								<strong>{total_working}</strong>
							</span>
						</span>
					</div>

					{this.getContent()}

					<Modal hideModal={this.props.hideModal} />
				</Layout>
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.timesReducer,
		...reducers.employeesReducer,
		...reducers.groupsReducer,
		...reducers.ubicationsReducer,
		...reducers.modalReducer,
		user: reducers.authReducer.user,
		loading: reducers.timesReducer.loading,
	};
};

const mapDispatchToProps = (dispatch) => ({
	...timesActions,
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	updateModalLoading: (isLoading) => dispatch(updateModalLoading(isLoading)),
	getSelectableEmployees: (options) =>
		dispatch(employeesActions.getSelectableEmployees(options)),
	getAllGroups: () => dispatch(groupsActions.getAllGroups({ sort: "+name" })),
	getSelectableUbications: () =>
		dispatch(ubicationsActions.getSelectableUbications()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Times));
